import Vue from 'vue'
import Router from 'vue-router'
import Home from './../views/Home.vue'
import about from './../views/About.vue'
import link_terkait from './../views/link_terkait/link_terkait.vue'

import berita from './../views/berita/berita.vue'
import login from './../views/auth/login.vue'

// AGENDA PENGUMUMAN
import agenda from './../views/agenda_pengumuman/agenda.vue'
import pengumuman from './../views/agenda_pengumuman/pengumuman.vue'
// AGENDA PENGUMUMAN

// DATA DAN INFORMASI
// DATA DAN INFORMASI

// E-GOV
// E-GOV

// GALLERY
import gallery_foto from './../views/gallery/foto.vue'
import gallery_video from './../views/gallery/video.vue'
// GALLERY


// PROFIL
import profil_kependudukan from './../views/profil/daerah/kependudukan.vue'
import profil_misi from './../views/profil/daerah/misi.vue'
import profil_kabupaten from './../views/profil/daerah/profil_kabupaten.vue'
import profil_sasaran from './../views/profil/daerah/sasaran.vue'
import profil_sejarah from './../views/profil/daerah/sejarah.vue'
import profil_tujuan from './../views/profil/daerah/tujuan.vue'
import profil_visi from './../views/profil/daerah/visi.vue'


import profil_data_pegawai from './../views/profil/kepegawaian/data_pegawai.vue'
import profil_bupati from './../views/profil/kepegawaian/profil_bupati.vue'
import profil_wabup from './../views/profil/kepegawaian/profil_wabup.vue'
import profil_sekda from './../views/profil/kepegawaian/profil_sekda.vue'

import profil_program_capaian from './../views/profil/program_capaian/program_capaian.vue'
// PROFIL

// SUBDOMAIN
import subdomain from './../views/subdomain/subdomain.vue'
// SUBDOMAIN

// GALLERY
import foto from './../views/gallery/foto.vue'
import video from './../views/gallery/video.vue'
// GALLERY


// FILTERING BERANDA
import filter_berita from './../views/filtering/filter_berita.vue'
import filter_foto from './../views/filtering/filter_foto.vue'
// FILTERING BERANDA

import dokumen_OPD from './../views/dokumen_OPD/dokumen_OPD.vue'




function loggedInRedirectDashboard(to, from, next) {
    if (localStorage.token) {
      next('/');
    } else {
      next();
    }
  }
  
  function isLoggedIn(to, from, next) {
    if (localStorage.token) {
      next();
    } else {
      next('/login');
    }
  }
  
  var routes = [

    {
        path: '/',
        name: 'home',
        component: Home,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/about',
        name: 'about',
        component: about,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/login',
        name: 'login',
        component: login,
        beforeEnter: loggedInRedirectDashboard,
      },
      {
        path: '/berita',
        name: 'berita',
        component: berita,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/agenda',
        name: 'agenda',
        component: agenda,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/pengumuman',
        name: 'pengumuman',
        component: pengumuman,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/gallery_foto',
        name: 'gallery_foto',
        component: gallery_foto,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/gallery_video',
        name: 'gallery_video',
        component: gallery_video,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_kependudukan',
        name: 'profil_kependudukan',
        component: profil_kependudukan,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_misi',
        name: 'profil_misi',
        component: profil_misi,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_kabupaten',
        name: 'profil_kabupaten',
        component: profil_kabupaten,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_sasaran',
        name: 'profil_sasaran',
        component: profil_sasaran,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_sejarah',
        name: 'profil_sejarah',
        component: profil_sejarah,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_tujuan',
        name: 'profil_tujuan',
        component: profil_tujuan,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_visi',
        name: 'profil_visi',
        component: profil_visi,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_data_pegawai',
        name: 'profil_data_pegawai',
        component: profil_data_pegawai,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_bupati',
        name: 'profil_bupati',
        component: profil_bupati,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_wabup',
        name: 'profil_wabup',
        component: profil_wabup,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_sekda',
        name: 'profil_sekda',
        component: profil_sekda,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/subdomain',
        name: 'subdomain',
        component: subdomain,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/profil_program_capaian',
        name: 'profil_program_capaian',
        component: profil_program_capaian,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/foto',
        name: 'foto',
        component: foto,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/video',
        name: 'video',
        component: video,
        beforeEnter: isLoggedIn,
      },
  
      {
        path: '/filter_berita',
        name: 'filter_berita',
        component: filter_berita,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/filter_foto',
        name: 'filter_foto',
        component: filter_foto,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/link_terkait',
        name: 'link_terkait',
        component: link_terkait,
        beforeEnter: isLoggedIn,
      },
      {
        path: '/dokumen_OPD',
        name: 'dokumen_OPD',
        component: dokumen_OPD,
        beforeEnter: isLoggedIn,
      },
 
 
  
  ]

  export default routes